// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const adminToken = localStorage.getItem("authToken");
  const superAdminToken = localStorage.getItem("token");

  // agar dono me se koi bhi token hai, route allow ho jayega
  if (adminToken || superAdminToken) {
    return children;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
